import {
  setCookie,
  getCookie,
  hasCookie,
  HAS_ALO_AUTH_TOKEN_STATE_COOKIE,
  redirect_to_with_cookie_creation
} from 'components_v2/common'

const multipassRedirect = () => {
  const allFreePath = window.location.pathname === '/all-free'
  if (allFreePath) return
  function shouldPoll() {
    return (
      (!hasCookie('alo_access_session_established') ||
        getCookie('alo_access_session_established') === 'false') &&
      !HAS_ALO_AUTH_TOKEN_STATE_COOKIE
    )
  }

  if (!shouldPoll()) return

  let delay = 1000
  const maxDelay = 30000
  const timeoutLimit = 30000
  let stopPolling = false
  const endPollingTimeout = setTimeout(() => {
    stopPolling = true
  }, timeoutLimit)

  const pollToken = () => {
    if (stopPolling || !shouldPoll()) return

    fetch(
      `/api/v2/sso/generate_multipass_token?redirect_to=${window.location.pathname}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (!data.isAloUser) {
          stopPolling = true
          clearTimeout(endPollingTimeout)
          return
        }

        if (data.retry_token) {
          delay = Math.min(delay * 2, maxDelay)
          setTimeout(pollToken, delay)
        } else if (data.alo_token) {
          setCookie('alo_access_session_established', 'true', 1 / 24)
          stopPolling = true
          redirect_to_with_cookie_creation(data.alo_token)
        }
      })
      .catch((err) => {
        console.error('Multipass polling error:', err)
      })
  }

  pollToken()
}

export default multipassRedirect
